// Sky DS mirror — policy 2026-06-04: the Figma DS sheet ("Components / Colors /
// Typo / Icons" → Colors, node 19702:12911) is the single source of truth.
// Token names mirror the Figma variable names 1:1; values pulled via MCP
// get_variable_defs (never eyeballed). Bernard-era LEGACY aliases were
// re-pointed to DS tokens per section and deleted at Step 18; darkGray/
// lightGray and tags.text are kept as part of the DS mirror even while unused.
export const colors = {
  buttons: {
    primary: '#2B76C2',
    primaryHover: '#3593F2',
    secondary: '#2D4762',
    secondaryHover: '#215E9C',
    dark: '#1B1D1F',
    darkHover: '#1B2D3F',
    light: '#B8D2EE',
    text: '#FFFFFF',
  },
  text: {
    light: '#A0AEB9', // Figma "Text/Light"
    accent: '#4D9EDC', // Figma "Text/Accent"
    accentBlue: '#46DDFF', // Figma "Text/Accent Blue"
    white: '#FFFFFF', // Figma "Text/White" — largest values + table headers
    active: '#3592F1', // Figma "Text/Active"
    darkGray: '#3B3D41', // Figma "Text/Dark gray" (variable only, not on swatch sheet)
    lightGray: '#ACB2BB', // Figma "Text/Light gray" (variable only, not on swatch sheet)
  },
  background: {
    light: '#365675',
    dark: '#15283B',
    accent: '#1C3B59',
    // #2B4B6B per the bound variable "Background/Medium" consumed by the Pages
    // frames; the swatch-sheet label (#1B446E) is stale — third such case (D7).
    medium: '#2B4B6B',
    transparent: '#1B436E7A', // Figma "Background/Transparent" @48%
    tooltip: '#364C61', // variable value; swatch-sheet label (#1B2937) is stale
  },
  elements: {
    primary: '#446383',
    secondary: '#497AAC', // Figma "UI Elements/Secondary" (new in Sky DS)
    accent: '#46DDFF',
    dark: '#15283B',
    skeletonPrimary: '#356BA1',
    skeletonSecondary: '#659ACE',
  },
  border: {
    primary: '#1A4671',
  },
  gradient: {
    // Figma "Gradient/Fade" swatch: #265F99 → #1B446E (left→right).
    // Direction/stops verified per-usage at section steps.
    fade: 'linear-gradient(90deg, #265F99 0%, #1B446E 100%)',
  },
  accent: {
    success: '#5EC952',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    // Sky DS "Tags/*" verbatim (no bernard-style deviation) — pastel pills,
    // dark text. Verify against the tables in Pages group B at Step 13.
    processing: '#88D5ED',
    success: '#BFE1A8',
    reject: '#FFA089',
    transfer: '#FFD889',
    mint: '#A8C8FF',
    text: '#3E3E3E',
  },
};
